import { getCurrentUserIdToken } from '@/firebase';

export function buildJsonAuthHeaders(token: string | null): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}

export async function getJsonAuthHeaders(): Promise<Record<string, string>> {
  return buildJsonAuthHeaders(await getCurrentUserIdToken());
}
